import { FONTS, GAPS, getColors, SIZES } from '../constants';
import { getTextMetrics } from '../helpers';
import { NotificationAction } from '../types';
import { drawText } from './text-drawer';

/**
 * Рисует DTMF-команду (круг с цифрой).
 * @returns ширина круга
 */
function drawDtmfCommand(ctx: CanvasRenderingContext2D, x: number, y: number, char: string): number {
    const radius = SIZES.dtmfCircle / 2;
    const colors = getColors();

    // Круг
    ctx.save();
    ctx.fillStyle = colors.dtmfCircleBackground;
    ctx.beginPath();
    ctx.arc(x + radius, y, radius, 0, 2 * Math.PI);
    ctx.fill();

    // Цифра
    ctx.font = FONTS.dtmfCommand;
    ctx.fillStyle = colors.dtmfCircleText;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';

    const metrics = getTextMetrics(ctx, char, FONTS.dtmfCommand);
    ctx.fillText(char, x + radius, y + metrics.offsetY);
    ctx.restore();

    return SIZES.dtmfCircle;
}

/**
 * Рисует действие с текстом и DTMF-командами.
 * @returns общая ширина области
 */
export function drawAction(ctx: CanvasRenderingContext2D, x: number, y: number, action: NotificationAction): number {
    let currentX = x;

    // Текст действия
    const labelWidth = drawText(ctx, currentX, y, action.label);
    currentX += labelWidth;

    // Добавляем gap только если есть и label, и команды
    if (labelWidth > 0 && action.command.length > 0) {
        currentX += GAPS.afterActionLabel;
    }

    // DTMF-команды
    for (let i = 0; i < action.command.length; i++) {
        const commandWidth = drawDtmfCommand(ctx, currentX, y, action.command[i]);
        currentX += commandWidth;

        if (i < action.command.length - 1) {
            currentX += SIZES.dtmfCircleGap;
        }
    }

    return currentX - x;
}
